// extracted by mini-css-extract-plugin
export default {"overlay":"image-lightbox_overlay__qsMLu","image":"image-lightbox_image__4K5Ku","closeButton":"image-lightbox_closeButton__ONKu-"};